import { GeneralSettingEditableField } from '../../../models/general-setting.model';

export const VIEW_USER_REPORT_ROUTES = {
  DASHBOARD: '/dashboard'
};

export const NUMBER_TYPE = 'number';
export const NON_NEGATIVE_NUMBER_MINIMUM = 0;

export const VACATION_POLICY_LIMITS = {
  MIN_ANNUAL_DAYS: 0,
  MAX_ANNUAL_DAYS: 365,
  MIN_WORKING_PERCENTAGE: 0,
  MAX_WORKING_PERCENTAGE: 100
};

export enum SettingsSection {
  NONE,
  STANDARDS,
  SUGGESTIONS,
  LEARNING,
  TASKS,
  VACATION,
  KARMA,
  AI,
  DEAL_PAYROLL,
}

export const VIEW_USER_REPORT_ADMIN_ROLE = 'ROLE_ADMIN';
export const VIEW_USER_REPORT_ROLE_NOT_FOUND_INDEX = -1;

export interface ViewUserReportRouteData {
  roles: string[];
  initialSettingsSection?: SettingsSection;
}

export const GENERAL_SETTINGS_ROUTE_DATA: ViewUserReportRouteData = {
  roles: [VIEW_USER_REPORT_ADMIN_ROLE]
};

export const DEAL_PAYROLL_SETTINGS_ROUTE_DATA: ViewUserReportRouteData = {
  roles: [VIEW_USER_REPORT_ADMIN_ROLE],
  initialSettingsSection: SettingsSection.DEAL_PAYROLL
};

export interface GeneralSettingViewField {
  action: GeneralSettingEditableField;
  labelKey: string;
  modalTitleKey: string;
}

export const GENERAL_SETTING_FIELD = {
  SKILL_TEST_QUESTIONS_COUNT: 'skillTestQuestionsCount' as GeneralSettingEditableField,
  SKILL_TEST_TIME_LIMIT_MINUTES: 'skillTestTimeLimitMinutes' as GeneralSettingEditableField,
  SKILL_TEST_PASSING_PERCENTAGE: 'skillTestPassingPercentage' as GeneralSettingEditableField,
};

const SET_VALUE_IN_UNITS_KEY = 'SET_VALUE_IN_UNITS';

function createSettingField(
  action: GeneralSettingEditableField,
  labelKey: string,
): GeneralSettingViewField {
  return { action, labelKey, modalTitleKey: SET_VALUE_IN_UNITS_KEY };
}

export const AI_SETTING_VIEW_FIELDS: GeneralSettingViewField[] = [
  createSettingField('testRetakeCooldownHours', 'TEST_RETAKE_COOLDOWN_HOURS'),
  createSettingField('testGenerationLimitPerUserPerSpecializationPerDay', 'TEST_GENERATION_LIMIT_PER_USER_PER_SPECIALIZATION_PER_DAY'),
  createSettingField('chatMaxOutputTokens', 'CHAT_MAX_OUTPUT_TOKENS'),
  createSettingField('testGenerationMaxOutputTokens', 'TEST_GENERATION_MAX_OUTPUT_TOKENS'),
  createSettingField('maxChatMessageLength', 'MAX_CHAT_MESSAGE_LENGTH'),
  createSettingField('chatHistoryMessageLimit', 'CHAT_HISTORY_MESSAGE_LIMIT'),
  createSettingField('chatMessagesPerUserPerDay', 'CHAT_MESSAGES_PER_USER_PER_DAY'),
  createSettingField('chatMessagesPerUserPerMinute', 'CHAT_MESSAGES_PER_USER_PER_MINUTE'),
  createSettingField('perUserDailyTokenLimit', 'PER_USER_DAILY_TOKEN_LIMIT'),
  createSettingField('globalDailyTokenLimit', 'GLOBAL_DAILY_TOKEN_LIMIT'),
  createSettingField('learningControlPeriodMonths', 'LEARNING_CONTROL_PERIOD_MONTHS'),
];

export const LEARNING_TEST_SETTING_VIEW_FIELDS: GeneralSettingViewField[] = [
  createSettingField(GENERAL_SETTING_FIELD.SKILL_TEST_QUESTIONS_COUNT, 'SKILL_TEST_QUESTIONS_COUNT'),
  createSettingField(GENERAL_SETTING_FIELD.SKILL_TEST_TIME_LIMIT_MINUTES, 'SKILL_TEST_TIME_LIMIT_MINUTES'),
  createSettingField(GENERAL_SETTING_FIELD.SKILL_TEST_PASSING_PERCENTAGE, 'SKILL_TEST_PASSING_PERCENTAGE'),
];



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-report/view-user-report.option.ts